import PropTypes from 'prop-types';
import React from 'react';

import { useProjectStore } from '@core/store';

import RDMD from '@ui/RDMD';

const rdmdOpts = { copyButtons: false };

function DescriptionField(props) {
  const { id, description } = props;
  const isRmdx = useProjectStore(s => s.data.features.mdx === 'enabled');

  if (!description) {
    return null;
  }
  if (typeof description === 'string') {
    return (
      <p className="field-description" data-testid={id}>
        <RDMD opts={rdmdOpts} renderer={isRmdx ? 'rmdx' : 'rdmd'}>
          {description}
        </RDMD>
      </p>
    );
  }

  return (
    <div className="field-description" data-testid={id}>
      {description}
    </div>
  );
}

DescriptionField.propTypes = {
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  id: PropTypes.string,
};

export default DescriptionField;
